import { CSSObject } from "styled-components";

const cssObjectForFloatingButton = (
	backgroundColorHex: string | undefined
): CSSObject => {
	return {
		backgroundColor: backgroundColorHex,
		".Icon svg": {
			fill: backgroundColorHex,
		},
	};
};

export default cssObjectForFloatingButton;
